// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__KcOlf","obliqueLineWrap":"membershipbadge_obliqueLineWrap__37sA6","obliqueLine":"membershipbadge_obliqueLine__3nLPW"};